import React, { useState } from 'react';
import { isMultipleOrBucketedFacet, isRangeFacet } from '../../utils';
import FilterOptionsList from './FilterOptionsList';
import FilterRangeSlider from './FilterRangeSlider';
export default function FilterGroup(props) {
    const { facet, setFilter, initialNumOptions = 10, sliderStep, facetSliderSteps } = props;
    const [isCollapsed, setIsCollapsed] = useState(false);
    const toggleIsCollapsed = () => setIsCollapsed(!isCollapsed);
    const onFilterSelect = (facetName) => (value) => {
        setFilter(facetName, value);
    };
    return (React.createElement("li", { className: 'cio-filter-group' },
        React.createElement("button", { className: 'cio-filter-header', type: 'button', onClick: toggleIsCollapsed },
            facet.displayName,
            React.createElement("i", { className: `cio-arrow ${isCollapsed ? 'cio-arrow-up' : 'cio-arrow-down'}` })),
        isMultipleOrBucketedFacet(facet) && (React.createElement(FilterOptionsList, { isCollapsed: isCollapsed, multipleFacet: facet, modifyRequestMultipleFilter: onFilterSelect(facet.name), initialNumOptions: initialNumOptions })),
        isRangeFacet(facet) && (React.createElement(FilterRangeSlider, { isCollapsed: isCollapsed, rangedFacet: facet, modifyRequestRangeFilter: onFilterSelect(facet.name), sliderStep: facetSliderSteps?.[facet.name] || sliderStep }))));
}
